import React from 'react';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';
import Button from '../../../../components/Button';
import './EventSaveNavbar.scss';

interface EventSaveNavbarProps {
  onSubmit: () => void;
  preview: () => void;
}
const EventSaveNavbar = (props: EventSaveNavbarProps) => {
  const { onSubmit, preview } = props;

  return (
    <FixedBottomNavBar className="event-save-navbar">
      <div className="button-group">
        <div className="left">
          {/*미리보기*/}
          <Button color="light" text="미리보기" onClick={() => preview()} />
        </div>

        <div className="right">
          <Button color="primary" text="저장" onClick={() => onSubmit()} />
        </div>
      </div>
    </FixedBottomNavBar>
  );
};

EventSaveNavbar.displayName = 'EventSaveNavbar';

export default EventSaveNavbar;
